import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, Row, Button } from 'reactstrap';
import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import { withRouter } from 'react-router-dom'
import logo from 'assets/img/brand/logo.svg'
import shield from 'assets/img/brand/shield.svg'
import Export from 'utils/export/Export';
import ReactSelect from 'react-select';
import Http from 'utils/http/Http';
import { ImportListRoute, ExportListRoute } from 'routes';
import './DefaultHeader.scss';

const propTypes = {
  children: PropTypes.node,
  keycloak: PropTypes.object,
  onFilterChange: PropTypes.func
};

const defaultProps = {
  filter: []
};

class DefaultHeader extends Component {

  constructor(props) {
    super(props);

    this.accessRoles = props.keycloak.realmAccess.roles;

    this.state = {
      canExport: (this.accessRoles.includes("export") ? true : false),
      canImport: (this.accessRoles.includes("import") ? true : false),
      name: "",
      exportQuantity: 0,
      accessRoles: [],
      filter: []
    };
  }

  componentDidMount = () => {

    this.props.keycloak.loadUserProfile().success(profile => {
      let name = profile.firstName;
      if (!name) {
        name = profile.lastName;
      } else {
        name += ' ' + profile.lastName;
      }
      if (!name) {
        name = profile.username;
      }

      localStorage.setItem("tie-username", profile.username);

      this.setState({
        name: name,
        accessRoles: this.props.keycloak.realmAccess.roles,
        filter: this.props.filter
      });
    });

    window.addEventListener("export-count-event", this.handleExportCountEvent);
    window.addEventListener("tags-change-event", this.loadFilterTags);
    this.handleExportCountEvent(); //init counter
    this.loadFilterTags();
  }

  componentWillUnmount() {
    window.removeEventListener("export-count-event", this.handleExportCountEvent);
    window.removeEventListener("tags-change-event", this.loadFilterTags);
  }

  handleExportCountEvent = () => {
    const exps = Export.load();

    this.setState({
      exportQuantity: exps.length
    });
  }

  loadFilterTags = () => {
    Http.get('tags?fields=LOOKUP').then(tags => {
      let values = tags.map(tag => {
        return {
          value: tag.id,
          label: tag.name
        }
      });

      this.setState({
        ...this.state,
        filterTagOptions: values
      });
    });
  }

  onFilterTagChangeHandle(newOption) {
    if (this.props.onFilterChange) {
      this.props.onFilterChange(newOption);
    }
    this.setState({
      ...this.state,
      filter: newOption
    });
  }

  logout() {
    this.props.keycloak.logout();
    localStorage.removeItem("tie-username");
  }

  manageAccount() {
    this.props.keycloak.accountManagement();
  }

  import() {
    this.props.history.push(ImportListRoute.path);
  }

  export() {
    this.props.history.push(ExportListRoute.path);
  }

  renderExportQuantity() {
    if (this.state.exportQuantity > 0) {
      return (<span className="text-light ml-md-1">{this.state.exportQuantity}</span>);
    }
    return;
  }

  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />

        <AppNavbarBrand className="navbar-brand-icon"
          full={{ src: shield, height: 30, alt: 'Philips Logo' }}
          minimized={{ src: shield, height: 30, alt: 'Philips Logo' }}
        />
        <AppNavbarBrand
          full={{ src: logo, height: 30, alt: 'Bifrost Logo' }}
          minimized={{ src: logo, height: 30, alt: 'Bifrost Logo' }}
        />

        {/* <Nav className="mr-auto flex-fill" navbar> {
          <ReactSelect className="w-50"
            isMulti
            value={this.state.filter}
            options={this.state.filterTagOptions}
            onChange={this.onFilterTagChangeHandle.bind(this)}
          />
        }</Nav> */}

        <Nav className="ml-auto nav-fill" navbar> {
          <Row >
            <ReactSelect className="filter-tags-header"
              isMulti
              value={this.state.filter}
              options={this.state.filterTagOptions}
              onChange={this.onFilterTagChangeHandle.bind(this)}
            />

            {this.state.canImport && (
              <Button className="btn-ghost-primary" title={ImportListRoute.name} onClick={this.import.bind(this)} >
                <i className={ImportListRoute.icon + " text-light"}></i>
              </Button>
            )}

            {this.state.canExport && (
              <Button className="btn-ghost-primary" title={ExportListRoute.name} onClick={this.export.bind(this)} >
                <i className={ExportListRoute.icon + " text-light"}></i> {this.renderExportQuantity()}
              </Button>
            )}


            <UncontrolledDropdown nav direction="down" className="ml-md-2 mr-md-3 mt-2">
              <DropdownToggle nav caret>
                <i className="fa fa-user"></i> {this.state.name}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={this.manageAccount.bind(this)}><i className="fa fa-user"></i>Manage account</DropdownItem>
                <DropdownItem onClick={this.logout.bind(this)}><i className="fa fa-lock"></i>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Row>
        }</Nav>

      </React.Fragment >
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default withRouter(DefaultHeader);
